<template>
  <div>
    <lazy-table v-model="staff_accesses" model="staff_accesses" ref="table" :params="query">
      <table class="table table-hover table-responsive w-100 d-block d-md-table index-table">
        <thead>
          <tr>
            <sortable-th v-model="sort" sort_key="created_at">{{ 'created_at' | t }}</sortable-th>
            <sortable-th v-model="sort" sort_key="accepted_by_customer">{{ 'accepted_by_customer' | t }}</sortable-th>
            <sortable-th v-model="sort" sort_key="accepted_by_staff">{{ 'accepted_by_staff' | t }}</sortable-th>
            <sortable-th v-model="sort" sort_key="hours_estimated">{{ 'hours_estimated' | t }}</sortable-th>
            <sortable-th v-model="sort" sort_key="hours_spent">{{ 'hours_spent' | t }}</sortable-th>
            <sortable-th v-model="sort" sort_key="price_per_hour">{{ 'price_per_hour' | t }}</sortable-th>
            <sortable-th v-model="sort" sort_key="start_time">{{ 'start_time' | t }}</sortable-th>
            <sortable-th v-model="sort" sort_key="end_time">{{ 'end_time' | t }}</sortable-th>
            <th>{{ 'action_log_path' | t }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="access in staff_accesses">
            <td>{{ access.created_at | datetime }}</td>
            <td>
              <i class="fa fa-check-circle text-success" v-if="access.accepted_by_customer"></i
              ><i class="fa fa-times-circle text-danger" v-else></i>
            </td>
            <td>
              <i class="fa fa-check-circle text-success" v-if="access.accepted_by_staff"></i
              ><i class="fa fa-times-circle text-danger" v-else></i>
            </td>
            <td>{{ access.hours_estimated }}</td>
            <td>{{ access.hours_spent }}</td>
            <td>{{ access.price_per_hour }} {{ customer.currency }}</td>
            <td>{{ access.start_time | datetime }}</td>
            <td>{{ access.end_time | datetime }}</td>
            <td><a v-if="access.action_log_path" :href="access.action_log_path" :target="'_blank'">Download</a></td>
            <td>
              <p class="text-danger" v-if="access.end_time">Access expired</p>
              <p class="text-danger" v-else-if="access.completed && !access.accepted_by_customer">
                Access rejected by customer
              </p>
              <button
                class="btn btn-primary"
                v-else-if="!access.completed && access.start_time"
                @click="end_staff_access(access)"
              >
                Complete access
              </button>
              <button
                class="btn btn-primary"
                v-else-if="access.accepted_by_customer && access.accepted_by_staff"
                @click="start_staff_access(access)"
              >
                Start access
              </button>
              <p class="text-warning" v-else-if="access.accepted_by_staff">Waiting customer acception</p>
              <button
                class="btn btn-primary"
                v-else-if="can('write_accept_staff_access')"
                @click="accept_staff_access(access)"
              >
                Accept
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </lazy-table>
    <customer-staff-complete-modal
      ref="staff_access_complete_modal"
      :customer="customer"
    ></customer-staff-complete-modal>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';
import { mapState } from 'vuex';
import config from '../../config';
export default {
  props: ['customer'],
  data: function () {
    return {
      staff_accesses: [],
      sort: '-created_at'
    };
  },
  methods: {
    async accept_staff_access(access) {
      await Api.update('staff_accesses', {
        id: access.id,
        accepted_by_staff: true
      }).then(() => {
        access.accepted_by_staff = true;
      });
    },
    async start_staff_access(access) {
      await Api.update('staff_accesses', {
        id: access.id,
        start_staff_access: true
      }).then(({ data }) => {
        access.start_time = data.start_time;
        access.end_time = data.end_time;
      });
    },
    async end_staff_access(access) {
      this.$refs.staff_access_complete_modal.open(access);
    },
    download_action_log(access) {}
  },
  computed: {
    ...mapState(['currentTenant']),
    query() {
      return {
        sort: this.sort,
        filter: { customer_id: this.customer.id }
      };
    }
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.$refs.table.load_debounce(true);
      }
    },
    query() {
      this.$refs.table.load_debounce(true);
    }
  }
};
</script>

<style scoped>
.index-table td {
  max-width: 110px;
}

i.fa {
  font-size: 20px;
}
</style>
